import Box from 'components/shared/Box'
import styled from 'styled-components'
import { respondAbove } from 'styles/mediaQueries'

export const FamilyLoaderWrapper = styled(Box)`
    min-height: 230px;
    border-radius: 8px;

    @media ${respondAbove.xl} {
        min-height: 176px;
    }
`
